
import { Mixins, Component, Prop, Watch, Vue } from 'vue-property-decorator'
import * as T from '@/types'
import S from '@/store'

import { formatShortDate } from '@/utils/utils-datetime'

import {
    UiEmptyState, 
    UiIcon, 
    UiList,
    UiListItem,
    UiLoadingOverlay,
    UiLoadMoreButton,
    UiSidebar,
    UiSidebarWrapper,
} from '@hubsolv/hubsolv-ui'

import UiDownloadButton from '@/components/ui/inputs/UiDownloadButton.vue'

@Component({
    components: {
        UiDownloadButton,
        UiEmptyState, 
        UiIcon, 
        UiList,
        UiListItem,
        UiLoadingOverlay,
        UiLoadMoreButton,
        UiSidebar,
        UiSidebarWrapper,
    },
})
export default class ViewCasesList extends Vue {

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    
    @Prop({type: Array, required: true}) items!: T.File[]
    @Prop({ type: Boolean, default: false }) loading!: boolean

    @Prop({ type: Boolean, default: false }) empty!: boolean
    @Prop({ type: Boolean, default: false }) moreExist!: boolean
    @Prop({ type: Boolean, default: false }) filtersExist!: boolean

}
